import { render, staticRenderFns } from "./Downloads.vue?vue&type=template&id=d2dd7844&scoped=true"
import script from "./Downloads.vue?vue&type=script&lang=ts"
export * from "./Downloads.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dd7844",
  null
  
)

export default component.exports